import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses, offerIncludes } from '../data/content';
import { CtaButton } from './CtaButton';
import { ProductCollage } from './ProductCollage';
import { BonusFan } from './BonusFan';
import { PrintCutShare } from './PrintCutShare';
import { SunRays } from './decor/SunRays';
export function FinalOffer() {
  return <section id="offer" aria-labelledby="offer-title" className="relative overflow-hidden bg-cream-deep" data-id="element-97" data-mp="1ch6bprl0bn30">
      <SunRays className="pointer-events-none absolute -right-40 -top-40 w-[560px] text-gold/20" data-id="element-98" data-mp="1lfi1xshyoiux" />
      <div className="relative mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-99" data-mp="204eheamcky5k">
        <h2 id="offer-title" className="mx-auto max-w-3xl text-balance text-center font-display text-[40px] leading-[1.04] text-navy sm:text-[58px]" data-id="element-100" data-mp="2067h15yjmi42">
          Obtenez dès aujourd’hui le Pack Complet d’Évangélisation
        </h2>

        <div className="mt-14 space-y-6" data-id="element-101" data-mp="246hvz84bciv2">
          <ProductCollage data-id="element-102" data-mp="247kk58a9477a" />
          <BonusFan data-id="element-103" data-mp="2445688sbd47g" />
        </div>

        <div className="mx-auto mt-12 grid max-w-5xl overflow-hidden rounded-3xl bg-white shadow-sheet ring-2 ring-coral/25 md:grid-cols-[1.2fr_1fr]" data-id="element-104" data-mp="1q8kx5pn4uyf">
          <div className="p-7 sm:p-9" data-id="element-105" data-mp="6qmituxj2oiq">
            <p className="text-xs font-extrabold uppercase tracking-[0.14em] text-coral-deep" data-id="element-106" data-mp="bn3dl7z8g14s">Votre pack numérique comprend :</p>
            <ul className="mt-5 space-y-3" data-id="element-107" data-mp="gnhhcdtswox0">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 font-bold text-navy" data-id="element-108" data-mp="knjhgijw1aa6">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-leaf-deep" strokeWidth={3} aria-hidden="true" data-id="element-109" data-mp="pmckfh1jtiw3" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-8 text-xs font-extrabold uppercase tracking-[0.14em] text-gold-deep" data-id="element-110" data-mp="zdh0yl6vhbt1">+ 5 bonus :</p>
            <ul className="mt-4 space-y-3" data-id="element-111" data-mp="14dbtet6aq9g7">
              {bonuses.map(b => <li key={b.number} className="flex items-start gap-3 font-bold text-navy" data-id="element-112" data-mp="18d43597feln5">
                  <GiftIcon className="mt-0.5 h-5 w-5 shrink-0 text-coral" aria-hidden="true" data-id="element-113" data-mp="35e06htsfo4s7" />
                  {b.name}
                </li>)}
            </ul>
          </div>

          <div className="flex min-w-0 flex-col items-center justify-center bg-cream px-5 py-8 text-center sm:p-9" data-id="element-114" data-mp="3e6ld6bisil0o">
            <p className="text-sm font-extrabold uppercase tracking-[0.12em] text-ink-mute" data-id="element-115" data-mp="39fv34kzf5tzn">
              Valeur totale <span className="line-through decoration-coral decoration-2" data-id="element-116" data-mp="3o3yds7oeptus">CHF 97</span>
            </p>
            <p className="mt-2 text-sm font-extrabold uppercase tracking-[0.14em] text-navy" data-id="element-117" data-mp="3j4v9ipg93rnv">Aujourd’hui seulement</p>
            <p className="font-display text-[80px] leading-[0.95] text-coral sm:text-[96px]" aria-label="CHF 22.90" data-id="element-118" data-mp="zs04sj94thn">
              <span className="mr-2 align-top text-[32px] leading-none sm:text-[40px]" data-id="element-119" data-mp="3t1zsyhipp90z">CHF</span>22<span className="align-top text-[40px] leading-none sm:text-[48px]" data-id="element-120" data-mp="22rybsik6hqvu">.90</span>
            </p>
            <p className="mt-3 max-w-[18rem] text-balance text-sm font-semibold leading-relaxed text-ink-soft" data-id="element-121" data-mp="1ys5yxtnr4yko">
              Paiement unique · Sans abonnement · Accès numérique immédiat
              <span className="block" data-id="element-122" data-mp="1sn819oapleg0">Mises à jour gratuites à vie.</span>
            </p>
            <CtaButton checkout block className="mt-6" data-id="element-123" data-mp="1evjqboc74w0m">
              Obtenir le Pack Complet d’Évangélisation maintenant
            </CtaButton>
            <p className="mt-5 text-xs font-extrabold uppercase tracking-[0.14em] text-navy" data-id="element-124" data-mp="14y5e60xb2te4">200+ versets bibliques • 20+ modèles</p>
            <div className="mt-3" data-id="element-125" data-mp="19yb9ps6p501h">
              <PrintCutShare data-id="element-126" data-mp="19yjojpmdqffb" />
            </div>
            <p className="mt-3 font-display text-xl italic text-leaf-deep" data-id="element-127" data-mp="vy0fcf66h3bk">Commencez dès aujourd’hui à semer l’Évangile.</p>
          </div>
        </div>
      </div>
    </section>;
}